import {
  FETCH_SURVEY_INIT,
  FETCH_SURVEY_SUCCESS,
  FETCH_SURVEY_FAILURE,
  FETCH_SURVEY_SAVE_INIT,
  FETCH_SURVEY_SAVE_SUCCESS,
  FETCH_SURVEY_SAVE_FAILURE,
  RESET_SURVEY
} from './types';
import API from './api';

export function resetSurvey() {
  return {
    type: RESET_SURVEY
  };
}

function fetchSurveySuccess(data) {
  return {
    type: FETCH_SURVEY_SUCCESS,
    payload: data
  };
}

function fetchSurveyFailure(error) {
  console.log(error);
  return {
    type: FETCH_SURVEY_FAILURE,
    error
  };
}

function fetchSurveyInit() {
  return {
    type: FETCH_SURVEY_INIT
  };
}

export function fetchSurvey() {
  return async dispatch => {
    dispatch(fetchSurveyInit());
    try {
      const resp = await API.data.getSurveyToAnswer();
      return dispatch(fetchSurveySuccess(resp));
    } catch (error) {
      return dispatch(fetchSurveyFailure(error));
    }
  };
}

/* save survey */

function fetchSaveSurveySuccess(data) {
  return {
    type: FETCH_SURVEY_SAVE_SUCCESS,
    payload: data
  };
}

function fetchSaveSurveyFailure(error) {
  console.log(error);
  return {
    type: FETCH_SURVEY_SAVE_FAILURE,
    error
  };
}

function fetchSaveSurveyInit() {
  return {
    type: FETCH_SURVEY_SAVE_INIT
  };
}

export function fetchSaveSurvey(answers) {
  return async dispatch => {
    dispatch(fetchSaveSurveyInit());
    try {
      const resp = await API.data.saveSurveyAnswers(answers);
      return dispatch(fetchSaveSurveySuccess(resp));
    } catch (error) {
      return dispatch(fetchSaveSurveyFailure(error));
    }
  };
}





// WEBPACK FOOTER //
// ./source/client/actions/survey/index.js